import styled, { css } from "styled-components";

export const FormStyle = styled.div`
    .form-header{
        color:#66B4D6 ;
    }
    .form-title{
        color:#3E3958;
        font-size:1.9vw;
    }
    .link-color{
        color:#3E3958;
        font-size:1.4vw;
    }
    .form-head{
        color:#3E3958;
        font-size:1.4vw;
    }
    .letter-spacing{
        letter-spacing: 2.5px;
    }
    .btn:hover{
        background-color:#2A799B;
        color:white !important;
        border:none;
    }
    
`;
